import { Injectable } from '@angular/core';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';

@Injectable()
export class IncentiveQuestService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getIncentives(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Loyalty/GetIncentives', data, messageService);
    }

    public addLoyaltyIncentive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Loyalty/AddLoyaltyIncentive', data, messageService);
    }
}
